import { render, staticRenderFns } from "./scoreboard_sets_large.vue?vue&type=template&id=61b343f5&scoped=true&"
import script from "./scoreboard_sets_large.vue?vue&type=script&lang=js&"
export * from "./scoreboard_sets_large.vue?vue&type=script&lang=js&"
import style0 from "./scoreboard_sets_large.vue?vue&type=style&index=0&id=61b343f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b343f5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EventTime: require('/var/web/bet777.es/components/event_time.vue').default})
